// Admin — marketplace product review. Reads the base table (admin-only by
// RLS); every change goes through admin_market_product_update, which is
// whitelisted and writes market_product_audit.

import { marketDb, marketRpc } from './marketDb';

const COLS = 'id, status, review_status, featured_rank, title_ar, title_en, title_zh, images, category, subcategory, product_type, classification, quality_flags, seller_name_latin, price_min_cny, price_max_cny, sku_count, skus_in_stock, created_at';

/** filter: 'pending' | 'review' | 'unclassified' | 'flagged' | 'hidden' | 'featured' | 'all'
 *  pending = imported by the ingestion pipeline and held for a person (not customer-visible). */
export async function adminMarketProducts(filter = 'review') {
  let q = marketDb.from('market_products').select(COLS).in('status', ['active', 'unavailable']).order('created_at', { ascending: false }).limit(500);
  if (filter === 'pending') q = q.eq('review_status', 'pending_review');
  if (filter === 'review') q = q.eq('classification->>status', 'review');
  if (filter === 'unclassified') q = q.or('classification->>status.eq.unclassified,subcategory.is.null');
  if (filter === 'flagged') q = q.neq('quality_flags', '{}');
  if (filter === 'hidden') q = q.eq('review_status', 'hidden');
  if (filter === 'featured') q = q.not('featured_rank', 'is', null).order('featured_rank');
  const { data, error } = await q;
  return { rows: data || [], error };
}

export const adminUpdateMarketProduct = (id, patch) => marketRpc('admin_market_product_update', { p_product_id: id, p_patch: patch });
export const adminQualityScan = () => marketRpc('admin_market_quality_scan', {});
/** Product counts for the console: totals and per main category / subcategory (admin_market_product_counts). */
export const adminMarketProductCounts = () => marketRpc('admin_market_product_counts', {});
export async function adminProductAudit(id) {
  const { data } = await marketDb.from('market_product_audit').select('id, actor_id, action, before, after, created_at').eq('product_id', id).order('id', { ascending: false }).limit(20);
  return data || [];
}
